"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatEmoteWithSet = void 0;
const tslib_1 = require("tslib");
const DataObject_1 = require("../DataObject");
const rtfm_1 = require("../rtfm");
const ChatEmote_1 = require("./ChatEmote");
/**
 * A chat emote from an emote set.
 *
 * @inheritDoc
 */
let ChatEmoteWithSet = class ChatEmoteWithSet extends ChatEmote_1.ChatEmote {
    /**
     * The ID of the emote set.
     */
    get setId() {
        return this[DataObject_1.rawDataSymbol].emoticon_set;
    }
};
ChatEmoteWithSet = tslib_1.__decorate([
    (0, rtfm_1.rtfm)('common', 'ChatEmoteWithSet', 'id')
], ChatEmoteWithSet);
exports.ChatEmoteWithSet = ChatEmoteWithSet;
